<template>
  <b-row>  
    <b-col lg="4" sm="12">
      <vs-button @click="deleteProperty()" color="danger" radius size="small" icon="remove"
        type="gradient" v-b-tooltip.hover.bottom="'Listeden Kaldır'"></vs-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  methods: {
    deleteProperty() { 
      this.$root.$emit("deleteProperty", this.params.data.id);
    }
  }
};
</script>
